import { Invitee, Meeting } from '../../types/plann3r'
import {
  RECEIVE_CURRENT_MEETINGS,
  RECEIVE_PAST_MEETINGS,
  REQUEST_CURRENT_MEETINGS,
  REQUEST_PAST_MEETINGS,
  SET_CURRENT_PAGE,
  SET_HISTORY_PAGE,
} from './actions'
import { MeetingManagementStore, MeetingManagementActionType } from './types'

const initialState: MeetingManagementStore = {
  current: {
    meetings: [],
    isFetching: true,
    page: 0,
    items_per_page: 5,
  },
  history: {
    meetings: [],
    isFetching: true,
    page: 0,
    items_per_page: 5,
  },
  pending: {
    meetings: [],
  },
}

export const reducer = (
  state = initialState,
  action: MeetingManagementActionType,
): MeetingManagementStore => {
  switch (action.type) {
    case REQUEST_CURRENT_MEETINGS:
      return {
        ...state,
        current: {
          isFetching: true,
          meetings: state.current.meetings,
          page: 0,
          items_per_page: 5,
        },
      }
    case RECEIVE_CURRENT_MEETINGS: {
      const pendingMeetings = action.meetings.filter((meeting: Meeting) => {
        return (
          (!meeting.isOwner &&
            meeting.invitees.find(
              (invitee: Invitee) => invitee.id === meeting.receiver,
            )?.status !== 'confirmed' &&
            meeting.invitees.find(
              (invitee: Invitee) => invitee.id === meeting.receiver,
            )?.status !== 'declined') ||
          (meeting.isOwner &&
            meeting.owner_has_to_accept &&
            !meeting.picked_moment)
        )
      })

      const currentMeetings = action.meetings.filter((meeting: Meeting) => {
        return (
          (meeting.isOwner && !meeting.owner_has_to_accept) ||
          (!meeting.isOwner &&
            meeting.invitees.find((invitee: Invitee) => {
              return invitee.id === meeting.receiver
            })?.status === 'confirmed')
        )
      })

      return {
        ...state,
        current: {
          isFetching: false,
          meetings: currentMeetings,
          page: 0,
          items_per_page: 5,
        },
        pending: {
          meetings: pendingMeetings,
        },
      }
    }

    case SET_CURRENT_PAGE:
      return {
        ...state,
        current: {
          isFetching: false,
          meetings: state.current.meetings,
          page: action.page,
          items_per_page: state.current.items_per_page,
        },
      }

    case REQUEST_PAST_MEETINGS:
      return {
        ...state,
        history: {
          isFetching: true,
          meetings: state.history.meetings,
          page: 0,
          items_per_page: 5,
        },
      }
    case RECEIVE_PAST_MEETINGS:
      return {
        ...state,
        history: {
          isFetching: false,
          meetings: action.meetings.sort((a: Meeting, b: Meeting) => {
            if (!a.picked_moment || !b.picked_moment) return 0
            return a.picked_moment.start < b.picked_moment.end ? 1 : -1
          }),
          page: 0,
          items_per_page: 5,
        },
      }

    case SET_HISTORY_PAGE:
      return {
        ...state,
        history: {
          isFetching: false,
          meetings: state.history.meetings,
          page: action.page,
          items_per_page: state.history.items_per_page,
        },
      }

    default:
      return state
  }
}
